<template>
  <CommonPage>
    <div class="login-content">
      <div class="header-section">
        <div class="logo-circle">
          <i class="el-icon-lock"></i>
        </div>
        <h3 class="box-title">
          <span class="title-text">维盟授权系统</span>
          <span class="subtitle">3.0</span>
        </h3>
      </div>
      <div class="switch-tabs">
        <div class="tab-indicator" :style="indicatorStyle"></div>
        <div 
          class="tab-item" 
          :class="{ active: type === 0 }"
          @click="type = 0"
        >
          <i class="el-icon-user"></i>
          <span>账号登录</span>
        </div>
        <div 
          class="tab-item" 
          :class="{ active: type === 1 }"
          @click="type = 1"
        >
          <i class="el-icon-mobile-phone"></i>
          <span>短信登录</span>
        </div>
      </div>
      <account-login v-if="type === 0" :key="0" @finish="loginSuccess"/>
      <sms-login v-else-if="type === 1" :key="1" @finish="loginSuccess"/>
    </div>
  </CommonPage>
</template>

<script>
  import CommonPage from "@view/components/CommonPage"
  import SmsLogin from "./components/SmsLogin.vue"
  import AccountLogin from "./components/AccountLogin.vue"
  export default {
    name: "index",
    components: {CommonPage,SmsLogin,AccountLogin},
    data() {
      return {
        type: 0,
      }
    },
    computed: {
      indicatorStyle() {
        return {
          left: this.type === 0 ? '6px' : 'calc(50% + 3px)',
        }
      }
    },
    methods: {
      loginSuccess(data) {
        this.$store.commit("setLoginInfo", {
          uid: data.uid,
          token: data.utoken,
          nickName: data.name,
          isAdmin: +data.is_super,
        });
        this.msgSuccess("登录成功");
        this.$router.replace("/index").catch(() => {});
      },
    },
  }
</script>

<style lang="scss" scoped>
  .login-content {
    .switch-tabs {
      display: flex;
      margin-bottom: 30px;
      background: #f3f4f6;
      border-radius: 50px;
      padding: 6px;
      position: relative;

      .tab-indicator {
        position: absolute;
        top: 6px;
        bottom: 6px;
        width: calc(50% - 9px);
        background: #2563eb;
        border-radius: 50px;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
        transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 1;
      }

      .tab-item {
        flex: 1;
        text-align: center;
        padding: 12px 0;
        border-radius: 50px;
        cursor: pointer;
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        position: relative;
        z-index: 2;

        i {
          font-size: 16px;
          transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        }

        &.active {
          color: white;
        }

        &:hover:not(.active) {
          color: #374151;
        }
      }
    }

    .header-section {
      text-align: center;
      margin-bottom: 20px;
      .logo-circle {
        width: 76px;
        height: 76px;
        margin: 0 auto 24px;
        border-radius: 24px;
        background: linear-gradient(135deg, #2563eb 0%, #3b82f6 50%, #60a5fa 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 24px rgba(37, 99, 235, 0.3);
        animation: logoFloat 3s ease-in-out infinite;

        @keyframes logoFloat {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }
        
        i {
          font-size: 36px;
          color: white;
        }
      }
      
      .box-title {
        margin: 0;
        line-height: 1.4;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        .title-text {
          display: block;
          font-size: 28px;
          font-weight: 700;
          background: linear-gradient(135deg, #1e40af 0%, #2563eb 50%, #3b82f6 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          letter-spacing: 4px;
        }
        
        .subtitle {
          display: inline-block;
          font-size: 14px;
          color: #6b7280;
          letter-spacing: 2px;
          font-weight: 500;
          padding: 4px 10px;
          background: linear-gradient(135deg, rgba(30, 58, 138, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);
          border-radius: 20px;
        }
      }
    }
    /deep/ {
      .login-form {
        .form-item {
          margin-bottom: 24px;
          animation: fadeInUp 0.6s ease-out;

          &:nth-child(1) {
            animation-delay: 0.1s;
          }
          &:nth-child(2) {
            animation-delay: 0.2s;
          }
          &:nth-child(3) {
            animation-delay: 0.3s;
          }
        }

        .input-wrapper {
          width: 100%;
          position: relative;
          display: flex;
          align-items: center;
          background: #f3f4f6;
          border-radius: 50px;
          border: 2px solid transparent;
          transition: all 0.3s ease;
          overflow: hidden;

          &:hover {
            background: #f3f4f6;
            border-color: #e5e7eb;
          }

          &:focus-within {
            border-color: #2563eb;
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
          }

          .input-icon {
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
              font-size: 20px;
              color: #9ca3af;
              transition: color 0.3s ease;
            }
          }

          &:focus-within .input-icon i {
            color: #2563eb;
          }

          .el-input {
            flex: 1;

            .el-input__inner {
              background: transparent;
              border: none;
              height: 52px;
              line-height: 52px;
              padding: 0 20px 0 0;
              font-size: 15px;
              border-radius: 50px;
              box-shadow: none;

              &::placeholder {
                color: #9ca3af;
              }
            }
          }
        }

        .code-input-container {
          display: flex;
          gap: 10px;
          align-items: stretch;

          .el-input-group__append {
            background-color: #f3f4f6;
            border: none;
            .el-button {
              background-color: transparent!important;
            }
          }

          .input-wrapper {
            flex: 1.6;
          }

          .code-btn {
            flex-shrink: 0;
            width: auto;
            min-width: 110px;
            height: 52px;
            border-radius: 50px;
            font-weight: 600;
            font-size: 14px;
            padding: 0 18px;
            transition: all 0.3s ease;

            &:hover:not(:disabled) {
              transform: translateY(-1px);
              box-shadow: 0 3px 10px rgba(37, 99, 235, 0.25);
            }
          }
        }

        .checkbox-wrapper {
          .checkbox-label {
            color: #6b7280;
            font-size: 14px;
          }
        }

        .checkbox-item {
          margin-bottom: 8px;
        }

        .image-code-box {
          width: 100px;
          box-sizing: border-box;
          cursor: pointer;
          overflow: hidden;
          border-radius: 50px;
          font-size: 0;
          margin-right: 10px;
          .el-image {
            width: 100%;
            height: 100%;
            .el-image__error {
              background-color: #f3f4f6;
              color: #9ca3af;
            }
          }
        }

        .login-btn {
          margin-top: 20px;
          width: 100%;
          height: 54px;
          font-size: 17px;
          font-weight: 600;
          letter-spacing: 4px;
          border-radius: 50px;
          position: relative;
          overflow: hidden;
          animation: fadeInUp 0.6s ease-out 0.4s both;

          .btn-icon {
            margin-left: 10px;
            opacity: 0;
            transform: translateX(-10px);
            transition: all 0.3s ease;
          }

          &:hover {
            .btn-icon {
              opacity: 1;
              transform: translateX(0);
            }
          }

          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
            transition: left 0.6s ease;
          }

          &:hover::before {
            left: 100%;
          }

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.6s ease;
          }

          &:active::after {
            width: 400px;
            height: 400px;
            opacity: 0;
          }
        }

        .el-button--primary {
          background: #2563eb;
          border: none;
          box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
          transition: all 0.2s ease;

          &:hover {
            background: #1d4ed8;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
          }
          &:active {
            background: #1e40af;
            box-shadow: 0 1px 4px rgba(37, 99, 235, 0.2);
          }
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #2563eb;
          border-color: #2563eb;
          animation: checkPop 0.4s ease;
        }

        .el-checkbox__inner {
          border-radius: 6px;
          transition: all 0.3s ease;
          width: 18px;
          height: 18px;
          &:after {
            height: 9px;
            left: 6px;
          }
        }

        .el-checkbox:hover .el-checkbox__inner {
          border-color: #3b82f6;
          transform: scale(1.1);
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes checkPop {
          0% {
            transform: scale(1);
          }
          30% {
            transform: scale(1.3) rotate(-8deg);
          }
          60% {
            transform: scale(1.15) rotate(4deg);
          }
          100% {
            transform: scale(1);
          }
        }
      }
    }
  }
</style>
